module.exports = __webpack_public_path__ + "static/media/3.ba36022c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pps/bobruisk/3.jpg
// module id = 212
// module chunks = 0